import React from "react";
import { Link } from "react-router-dom";
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardTitle,
  CCardText,
  CButton,
} from "@coreui/react";

const phongBanList = [
  { id: 1, ten: "Phòng Nhân Sự", moTa: "Quản lý nhân sự và tuyển dụng" },
  { id: 2, ten: "Phòng Kế Toán", moTa: "Xử lý tài chính, kế toán" },
  { id: 3, ten: "Phòng Marketing", moTa: "Quảng cáo và tiếp thị" },
];

const PhongBan = () => {
  return (
    <CContainer>
      <h2 className="my-4">Danh sách phòng ban</h2>
      <CRow>
        {phongBanList.map((phong) => (
          <CCol xs={12} sm={6} md={4} key={phong.id}>
            <CCard className="mb-3 shadow-sm">
              <CCardBody>
                <CCardTitle>{phong.ten}</CCardTitle>
                <CCardText>{phong.moTa}</CCardText>
                <Link to={`/phongban/${phong.id}`}>
                  <CButton color="primary">Xem chi tiết</CButton>
                </Link>
              </CCardBody>
            </CCard>
          </CCol>
        ))}
      </CRow>
    </CContainer>
  );
};

export default PhongBan;
